import { render, staticRenderFns } from "./Item-horizontal.vue?vue&type=template&id=3403727c&scoped=true&"
import script from "./Item-horizontal.vue?vue&type=script&lang=js&"
export * from "./Item-horizontal.vue?vue&type=script&lang=js&"
import style0 from "./Item-horizontal.vue?vue&type=style&index=0&id=3403727c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3403727c",
  null
  
)


    import installComponents from "!C:/Projects/rentmagic.website.vue.limburg/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow})
    

export default component.exports